<template lang="html">
  <div class="empty-state-container d-table">
    <a
      @click="createCapsule"
      class="empty-state text-center d-table-cell align-middle"
      @mouseenter="toggleHover"
      @mouseleave="toggleHover"
    >
      <MannequinIcon
        width="124px"
        height="124px"
        :active="hovering"
        class="mb-4"
      />
      <h3 class="align-middle primary">No capsules yet...</h3>
      <br />
      <p class="lead secondary">Click <b>here</b> to get started.</p>
    </a>
  </div>
</template>

<script>
import MannequinIcon from "@/components/capsule/icons/Mannequin.vue";
import { bus } from "@/main";

export default {
  name: "TailorEmptyStateContent",

  components: {
    MannequinIcon,
  },

  data() {
    return {
      hovering: false,
      requestingNewCapsule: false,
    };
  },

  methods: {
    toggleHover() {
      this.hovering = !this.hovering;
    },

    createCapsule() {
      if (!this.requestingNewCapsule) {
        this.requestingNewCapsule = true;
        bus.$emit("requestCreateCapsule");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.empty-state-container {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  margin-top: 50px;
}

.empty-state {
  cursor: pointer;
  font-weight: 300;
  text-decoration: none;
  color: #a9a9a9;

  .primary,
  .secondary {
    font-weight: 300;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tailor/TailorEmptyStateContent.vue